<template>
  <div :class="{ 'pwa-install-wrap': customerBtn }">
    <div
      class="add-to-home j-add-to-home"
      :class="{ 'add-to-home-customer': customerBtn }"
      :style="customerBtn ? 'margin: 0; padding: 0' : ''"
      @click="handlePwaInstallClick"
    >
      <slot v-if="customerBtn" name="customerBtn"></slot>
      <template v-else>
        <Icon class="ico" name="add-desktop"></Icon>
        <span class="text">{{ letter.voucherAddHome }}</span>
        <transition name="fade">
          <div
            class="pwa-popover flex-center"
            v-if="!showAccountSelecter && visiblePopover"
          >
            <img
              v-if="popoverIco"
              class="popover-ico"
              :src="popoverIco"
              alt="popover-ico"
            />
            <span class="popover-text">{{ letter.v3AddShortcutForBonus }}</span>
            <div class="sanjiao"></div>
            <a
              href="javascript:void(0)"
              class="pwa-popover-close"
              @click="visiblePopover = false"
              >&times;</a
            >
          </div>
        </transition>
      </template>
    </div>
    <transition name="fade">
      <safari-pwa-guide-popup
        v-if="isGuide"
        @closePopup="hideSafariTip"
      ></safari-pwa-guide-popup>
    </transition>
    <transition name="fade">
      <pwa-install-award-popup
        v-if="visibleInstallAwardPopup"
        @install="pwaInstallFromPopup"
        @close="closePwaInstallAwardPopup"
      ></pwa-install-award-popup>
    </transition>
    <transition name="fade">
      <pwa-common-popup
        v-if="visibleCommonPopup"
        @closePopup="hideCommonPopup"
      ></pwa-common-popup>
    </transition>
 
    <transition name="fade">
      <pwa-goto-award-tips-popup
        v-if="visibleGotoAwardTipsPopup"
        @close="switchVisibleGotoAwardTipsPopup"
      ></pwa-goto-award-tips-popup>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { commonEmitUpload } from '../../../plugins/AnalyzePoint/index';
import { isSafari } from '@utiles/officialStore/device';
import SafariPwaGuidePopup from '@components/officialTopupNew/pwa/SafariPwaGuidePopup.vue';
import PwaInstallAwardPopup from '@components/officialTopupNew/pwa/PwaInstallAwardPopup.vue';
import PwaCommonPopup from '@components/officialTopupNew/pwa/PwaCommonPopup.vue';
import globalConfig from '@utiles/officialStore/globalConfig';
import { b64DecodeUnicode } from '@utiles/officialStore';
import {
  popupType,
  showPopup,
  clickButton
} from '@plugins/biPoint/_configWebstoreV35';
import {
  UPDATE_IS_INSTALL,
  UPDATE_IS_CLOSE_PWA_POPUP,
  UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP
} from '@store/officialTopupNew/page';

import pwaMixin from '@mixins/pwa';
import PwaGotoAwardTipsPopup from '@components/officialTopupNew/pwa/PwaGotoAwardTipsPopup.vue';
export default {
  components: { SafariPwaGuidePopup, PwaInstallAwardPopup, PwaCommonPopup, PwaGotoAwardTipsPopup },
  mixins: [pwaMixin],
  name: 'PwaInstallTop',
  props: {
    /**
      1=弹窗保存
      2=支付结果页保存
      3=页面按钮保存
     */
    location: { 
      type: Number,
      default: 3
    }
  },
  data() {

    return {
      isSafari: isSafari(),
      isGuide: false,
      isHideAdd:
        globalConfig.getHrefParam('cid') === 'shortcut' ||
        globalConfig.getHrefParam('scid').includes('shortcut') || 
        globalConfig.getHrefParam('mode') == 'pwa',
      visibleInstallAwardPopup: false,
      visiblePopover: true,
      visibleCommonPopup: false,
    };
  },
  computed: {
    ...mapState({
      openPwa: state => state.page.openPwa,
      visibleGotoAwardTipsPopup: state => state.page.visibleGotoAwardTipsPopup
    }),
    ...mapGetters(['isJpPlatform']),
    customerBtn() {
      return this.$slots.customerBtn;
    },
    isInstall() {
      return this.$store.state.page.isInstall.value;
    },
    popoverIco() {
      return this.$store.state.page.picList?.pwagift;
    },
    letter() {
      return this.$store.state.letter;
    },
    gameId() {
      return this.$store.state.gameId;
    },
    showAccountSelecter() {
      return this.$store.state.login.showAccountSelecter;
    }
  },
  watch:{
    isInstall(newVal) {
      try {
       if(newVal == false) {
         this.isAutoShowPwaPopup('watch');
       }
      } catch (error) {
       
      }
    }
  },
  mounted() {
    this.isAutoShowPwaPopup('mounted');
    // app安装了
    window.addEventListener('appinstalled', () => {
      this.setIsInstall();
      // 回收 deferredPrompt 变量
      window.deferredPrompt = null;
      // pwa成功安装
      commonEmitUpload('success-install-pwa', {
        event: 'success-install-pwa',
        newPage: false,
        type: 'change'
      });
    });
  },
  methods: {
    sendAddToHomePoint(from) {
      clickButton({
        btnName: 'add_to_screen',
        locationKey: this.$route.meta.pageName,
        otherParams: from === 'popup' ? 1 : this.location
      });
    },
    setIsInstall() {
      this.$store.commit(UPDATE_IS_INSTALL, true);
    },
    // 处理 PWA 安装点击事件
    handlePwaInstallClick(from) {
      if (this.gameId == 191) {
        if (this.shouldShowPwaTips()) {
          // 如果是 Safari，显示 Safari 引导弹窗，否则显示通用弹窗
          this.isSafari ? this.showSafariTip(from) : this.showCommonPopup(from);
        } else {
          // 支持 PWA 的浏览器：调用安装 API
          this.installPwa(from);
        }
        return;
      }
      this.isSafari ? this.showSafariTip() : this.installPwa();
    },
    showSafariTip(from) {
      this.isGuide = true;
      this.sendAddToHomePoint(from);
      showPopup(popupType.safariAddToHomePopup);
    },
    hideSafariTip() {
      this.isGuide = false;
      this.switchVisibleGotoAwardTipsPopup(true);
    },
    showCommonPopup(from) {
      this.sendAddToHomePoint(from);
      this.visibleCommonPopup = true;
    },
    hideCommonPopup() {
      this.visibleCommonPopup = false;
      this.$store.commit(UPDATE_IS_CLOSE_PWA_POPUP, true);
      this.switchVisibleGotoAwardTipsPopup(true);
    },
    updateUrlWithParams(currentUrl, newParams) {
      // 解析当前 URL
      const url = new URL(currentUrl);
      // 遍历并更新/添加新的查询参数
      Object.keys(newParams).forEach(key => {
        url.searchParams.set(key, newParams[key]);
      });
      // 返回更新后的 URL 字符串
      return url.toString();
    },
    installPwa(from) {
      // 用户点击页面上的安装按钮
      commonEmitUpload('click-install-pwa-btn', {
        event: 'click-install-pwa-btn',
        newPage: false,
        type: 'click'
      });
      this.sendAddToHomePoint(from);
      if (!window.deferredPrompt) return;
      window.deferredPrompt.prompt();
      window.deferredPrompt.userChoice.then(result => {
        if (result.outcome == 'dismissed') {
          // 用户点击页面上的安装按钮
          commonEmitUpload('cancel-install-pwa', {
            event: 'cancel-install-pwa',
            newPage: false,
            type: 'click'
          });
        } else if (result.outcome == 'accepted') {
          window.setIsInstall();
          this.setIsInstall();
          window.deferredPrompt = null;

          // 用户点击页面上的安装按钮
          commonEmitUpload('accept-install-pwa', {
            event: 'accept-install-pwa',
            newPage: false,
            type: 'click'
          });

          let store_url_params = decodeURIComponent(
            globalConfig
              .getHrefParam('store_url_params')
              .replace('#/result', '')
          );
          let storeParams = b64DecodeUnicode(store_url_params);
          let postOrderParams = {};
          try {
            postOrderParams = JSON.parse(storeParams);
          } catch (e) {
            console.error(e);
          }
          // 2026-01-21 存一下，用来刷新页面后展示领奖提示弹窗
          try {
             sessionStorage.setItem(`${this.gameId}_pwa_install_click`, 1);

          } catch (error) {
            
          }

          // 2025-01-08 同manifest动态生成的参数链接一致
          let curCid = globalConfig.getHrefParam('cid') || postOrderParams.cid;
          let curScid =
            globalConfig.getHrefParam('scid') || postOrderParams.scid;

          let curLink = window.location.href;
          if (/#\/result$/.test(window.location.href)) {
            curLink = window.location.origin + window.location.pathname;
          }
          try {
            let link = this.updateUrlWithParams(
              window.location.href.replace('#/result', ''),
              {
                cid: curCid,
                scid: curScid,
                mode: 'pwa'
              }
            );
            window.location.href = window.globalGetGotoLink({ link });
          } catch (e) {
            console.error(e);
          }
        }
      });
    },
    pwaInstallFromPopup() {
      this.closePwaInstallAwardPopup();
      this.handlePwaInstallClick('popup');
    },
    closePwaInstallAwardPopup() {
      this.visibleInstallAwardPopup = false;
    },
    switchVisiblePwaInstallAwardPopup(bool) {
      if (!this.openPwa) return;
      this.visibleInstallAwardPopup = bool;

      if (bool) {
        // 记录本次打开的时间点
        window?.localStorage?.setItem(
          `lastShowPwaInstallPopupDate${this.gameId}v2`,
          new Date().getTime()
        );
        // 打点上报
        showPopup(popupType.pwaInstallPopup);
      }
    },
    switchVisibleGotoAwardTipsPopup(bool) {
      // this.visibleGotoAwardTipsPopup = bool;
      this.$store.commit(UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP, bool);
    },
    isAutoShowPwaPopup(from) {
     
      // 2026-01-21 如果已经安装或者从pwa打开，就不弹窗
      if((this.isInstall && !this.isSafari)  || this.isHideAdd) return;
      const lastShowPwaInstallPopupDate = window?.localStorage?.getItem(
        `lastShowPwaInstallPopupDate${this.gameId}v2`
      );
      if (lastShowPwaInstallPopupDate) {
        const lastDate = new Date(
          Number(lastShowPwaInstallPopupDate)
        ).getTime();
        const nowDate = new Date().getTime();

        // 如果是7天之前就展示
        // 2026-01-21 现在改成3天
        if (nowDate - lastDate > 3 * 24 * 60 * 60 * 1000) {
          this.switchVisiblePwaInstallAwardPopup(true);
        }
      } else {
        this.switchVisiblePwaInstallAwardPopup(true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';

.pwa-install-wrap {
  width: 100%;
  height: 100%;
}

.add-to-home {
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  padding: 0 20px;
  margin-right: 20px;
  border-radius: 30px;
  font-size: 22px;
  color: #fff;

  cursor: pointer;
  &-customer {
    width: 100%;
    height: 100%;
    padding: 0;
  }
  .ico {
    display: block;
    margin-right: 10px;
    color: #ffffff;
    width: 30px;
    height: 26px;
  }
  .pwa-popover {
    position: relative;
    max-width: 500px;
    min-width: 287px;
    background: linear-gradient(
      348deg,
      $buttonGradientColor1,
      $buttonGradientColor2
    );
    border-radius: 6px;
    display: none;
    position: absolute;
    top: 66px;
    box-sizing: border-box;
    padding: 10px 30px 10px 10px;
    text-align: left;
    font-size: 16px;
    line-height: 1.2;

    &-close {
      position: absolute;
      top: -4px;
      right: 4px;
      font-size: 26px;
      color: #ffffff;
      cursor: pointer;
    }

    .popover-ico {
      margin-right: 10px;
      width: 28px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .sanjiao {
      position: absolute;
      top: -15px;
      left: 50%;
      transform: translateX(-50%);
      width: 30px;
      height: 15px;
      background: linear-gradient(
        348deg,
        $buttonGradientColor2,
        $buttonGradientColor1
      );
      clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    }
  }
}

#ssr-page.landscape {
  .add-to-home {
    font-size: 16px;
    background: linear-gradient(
      348deg,
      $buttonGradientColor2,
      $buttonGradientColor1
    );
    .pwa-popover {
      display: flex;
    }
  }
  .pwa-home-result {
    .add-to-home {
      background: none;
    }
  }
}
</style>
